import * as Request from "../commons/request";
import { utilAxiosWithAuth } from "./customAxios";

/**
 * Apollo 자율주행 모니터링 API 헬퍼 (REST 폴링; 설계 §6.2).
 * 응답은 { result:"ok", <key>: data } 형태.
 */
export const getApolloVehicles = async () => {
    const res = await utilAxiosWithAuth().get(Request.APOLLO_VEHICLES_URL);
    return res.data;
};

export const getApolloLatest = async (carId: number) => {
    const res = await utilAxiosWithAuth().get(Request.APOLLO_LATEST_URL(carId));
    return res.data;
};

export const getApolloMap = async (carId: number) => {
    const res = await utilAxiosWithAuth().get(Request.APOLLO_MAP_URL(carId));
    return res.data;
};

export const getApolloPath = async (carId: number, from: string, to: string) => {
    const res = await utilAxiosWithAuth().get(Request.APOLLO_PATH_URL(carId), { params: { from, to } });
    return res.data;
};

// ── 경로 편집/주행 제어(하향 명령) ──

/** 경로 전송(SendRoutingRequest). 좌표는 프론트 로컬 프레임. start=null 이면 차량 현재 위치. */
export const postApolloRoute = async (
    carId: number,
    waypoints: { x: number; y: number }[],
    start: { x: number; y: number } | null
) => {
    const res = await utilAxiosWithAuth().post(Request.APOLLO_ROUTE_URL(carId), { waypoints, start });
    return res.data;
};

/** 명령 상태 조회(폴링용). */
export const getApolloCommand = async (carId: number, commandId: string) => {
    const res = await utilAxiosWithAuth().get(Request.APOLLO_COMMAND_URL(carId, commandId));
    return res.data;
};

/** 자율주행 개시(ENTER_AUTO_MODE) — 실차 이동. ADMIN 전용. */
export const postApolloDriveStart = async (carId: number) => {
    const res = await utilAxiosWithAuth().post(Request.APOLLO_DRIVE_START_URL(carId), {});
    return res.data;
};

/** 수동 전환(DISENGAGE) — 정지/해제. ADMIN/MANAGER. */
export const postApolloDriveStop = async (carId: number) => {
    const res = await utilAxiosWithAuth().post(Request.APOLLO_DRIVE_STOP_URL(carId), {});
    return res.data;
};
